export const validateField = (values) => {
  let errors = {}
  if (!values.companyCode) {
    errors.companyCode = 'Required!'
  }
  if (!values.bankName) {
    errors.bankName = 'Required!'
  }
  if (!values.limit) {
    errors.limit = 'Required!'
  }else{
    if(Number(values.limit)<Number(values.usage)){
      errors.limit = 'Amount of limit must be equal or greater than usage amount.'
    }
  }
  
  
  return errors
}